// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ae40ea87","239":"3bff169f","453":"7157373e","667":"861b5800"}[chunkId] + ".chunk.js";
};